export function httpUrlToWebSocketUrl(url) {
    return url.replace(/(http)(s)?\:\/\//, "ws$2://") + '/api/ws/graphql/';
}